import { useTranslation } from 'react-i18next';
import { AgentTools, type ToolCall, type ToolCallSummary } from '@/features/types/tools';
import { ToolCallContainer } from '../../ToolCallContainer';
import { ToolCallContentBox } from '../../ToolCallContentBox';
import { useToolCallParser, ToolCallState } from '../../useToolCallParser';
import { ToolCallError } from '../../ToolCallError';

interface QueryAllTool {
  name: AgentTools.sf_query_all;
  args: {
    query: string;
    maxRecords?: number;
  };
}
export type QueryAllToolCall = ToolCall<QueryAllTool['name'], QueryAllTool['args']>;

export type QueryAllToolCallSummary = ToolCallSummary<QueryAllTool['name'], QueryAllTool['args']>;

interface QueryAllResult {
  records: Record<string, unknown>[];
  done: boolean;
  totalSize?: number;
}

export function QueryAllToolCall({ toolCall }: { toolCall: QueryAllToolCallSummary }) {
  const { t } = useTranslation('prince');

  const { parsedResult, title } = useToolCallParser<QueryAllResult>(
    toolCall,
    ({ toolCallState }) => {
      switch (toolCallState) {
        case ToolCallState.Running:
          return t('toolCalls.sf_query_all.title.whileRunning');
        case ToolCallState.Error:
          return t('toolCalls.sf_query_all.title.errors');
        case ToolCallState.Success:
          return t('toolCalls.sf_query_all.title.success');
      }
    }
  );

  const tabs = [
    {
      id: 'results',
      label: t('toolCalls.results'),
      showLoadingWhileRunning: true,
      content:
        !toolCall.isRunning && parsedResult ? (
          parsedResult.hasErrors ? (
            <ToolCallError parsedResult={parsedResult} />
          ) : (
            <ToolCallContentBox content={toolCall.results} />
          )
        ) : null,
    },
    {
      id: 'query',
      label: t('toolCalls.query'),
      content: <ToolCallContentBox content={toolCall.args.query} />,
    },
  ];

  return (
    <ToolCallContainer
      toolName={toolCall.name}
      title={title}
      isRunning={toolCall.isRunning}
      tabs={tabs}
    />
  );
}
